import React, { useEffect, useRef, useState } from 'react';

const RangeSlider = ({ min, max, value = [min, max], onChange }) => {
    const [isDragging, setIsDragging] = useState(null); // 'left', 'right', or null
    const sliderRef = useRef(null);
    const leftHandleRef = useRef(null);
    const rightHandleRef = useRef(null);

    useEffect(() => {
        // Set initial values if not provided
        if (!value || value.length === 0) {
            onChange([min, max]);
        }
    }, [min, max]);

    const getPositionFromValue = (val) => {
        return ((val - min) / (max - min)) * 100;
    };

    const getValueFromPosition = (position) => {
        const percentage = Math.max(0, Math.min(100, position));
        const value = ((max - min) * percentage) / 100 + min;
        return Math.round(value);
    };

    const handleMouseDown = (e, handle) => {
        e.preventDefault();
        setIsDragging(handle);
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isDragging || !sliderRef.current) return;

            const rect = sliderRef.current.getBoundingClientRect();
            const position = ((e.clientX - rect.left) / rect.width) * 100;

            const newValue = getValueFromPosition(position);
            const [leftValue, rightValue] = value;

            if (isDragging === 'left') {
                if (newValue < rightValue) {
                    onChange([newValue, rightValue]);
                }
            } else {
                if (newValue > leftValue) {
                    onChange([leftValue, newValue]);
                }
            }
        };

        const handleMouseUp = () => {
            setIsDragging(null);
        };

        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, value, min, max]);

    const leftPos = getPositionFromValue(value[0]);
    const rightPos = getPositionFromValue(value[1]);

    return (
        <div
            ref={sliderRef}
            style={{
                position: 'relative',
                height: '4px',
                background: '#e5e7eb',
                borderRadius: '2px',
                cursor: 'pointer',
                margin: '10px 0'
            }}
        >
            {/* Track fill */}
            <div
                style={{
                    position: 'absolute',
                    height: '100%',
                    background: '#10b981',
                    borderRadius: '2px',
                    left: `${leftPos}%`,
                    right: `${100 - rightPos}%`
                }}
            />

            {/* Handles */}
            <div
                ref={leftHandleRef}
                style={{
                    position: 'absolute',
                    width: '14px',
                    height: '14px',
                    background: '#10b981',
                    borderRadius: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    left: `${leftPos}%`,
                    cursor: 'pointer',
                    zIndex: isDragging === 'left' ? 2 : 1
                }}
                onMouseDown={(e) => handleMouseDown(e, 'left')}
            />
            <div
                ref={rightHandleRef}
                style={{
                    position: 'absolute',
                    width: '14px',
                    height: '14px',
                    background: '#10b981',
                    borderRadius: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    left: `${rightPos}%`,
                    cursor: 'pointer',
                    zIndex: isDragging === 'right' ? 2 : 1
                }}
                onMouseDown={(e) => handleMouseDown(e, 'right')}
            />
        </div>
    );
};

export default RangeSlider;
